module.exports = __webpack_public_path__ + "static/img/libTasks.13004fff.png";